import { Popover as AntPopover } from 'antd';
import React, { ComponentPropsWithRef, FC, forwardRef } from 'react';
import styled from 'styled-components';

type Props = Omit<
  ComponentPropsWithRef<typeof AntPopover>,
  'title' | 'overlay' | 'overlayClassName'
> & {
  isDisabled?: boolean;
};

const PopoverComponent: FC<Props> = forwardRef((props, ref) => (
  <AntPopover
    overlayClassName={props.className}
    ref={ref}
    {...props}
    key={props.key as React.Key | undefined}
  />
));

export const Popover = styled(PopoverComponent)<Props>`
  &,
  .ant-popover-inner-content {
    padding: 0;
  }

  .ant-popover-arrow {
    display: none;
  }

  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
`;
